import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { MyPagesComponent } from './about/about.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  // cosmetology , epilation , massage , surgery , dermatology , news
  {
    path: 'news',
    children: [
      {
        path: '**',
        component: MyPagesComponent
      }
    ]
  },{
    path: 'dermatology',
    children: [
      {
        path: '**',
        component: MyPagesComponent
      }
    ]
  },{
    path: 'massage',
    children: [
      {
        path: '**',
        component: MyPagesComponent
      }
    ]
  },{
    path: 'surgery',
    children: [
      {
        path: '**',
        component: MyPagesComponent
      }
    ]
  },{
    path: 'epilation',
    children: [
      {
        path: '**',
        component: MyPagesComponent
      }
    ]
  },{
    path: 'cosmetology',
    children: [
      {
        path: '**',
        component: MyPagesComponent
      }
    ]
  },
];

export const routing = RouterModule.forRoot(routes, {useHash: true});



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.routing.ts